var map = {
	"./ai/spanBorder.svg": 384,
	"./computernaya-gramotnost/spanBorder.svg": 385,
	"./ege-informatika/spanBorder.svg": 354,
	"./frontend/spanBorder.svg": 386,
	"./game-design/spanBorder.svg": 387,
	"./graphic-design-pro/spanBorder.svg": 388,
	"./graphic-design/spanBorder.svg": 389,
	"./intensive/spanBorder.svg": 390,
	"./osnovy-programmirovaniya/spanBorder.svg": 391,
	"./predprinimatelstvo/spanBorder.svg": 392,
	"./python/spanBorder.svg": 393,
	"./scratch/spanBorder.svg": 394,
	"./unity/spanBorder.svg": 395,
	"./videoblogging/spanBorder.svg": 396,
	"./web-razrabotka/spanBorder.svg": 397
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 757;